<template>
  <canvas ref="graph-bar"></canvas>
</template>

<script>
import Chart from 'chart.js';
import {CORE_ASSESSMENT_NAMES} from '@/views/app/view_member/charts/core_assessments';

export default {
  name: 'checkup-results-barchart',
  props: {
    values: Object,
    showAnimation: {
      type: Boolean,
      default: false
    },
    showLabels: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      chartRef: null,
      config: {
        type: 'bar',
        data: {
          labels: [],
          datasets: [
            {
              id: [],
              data: [],
              backgroundColor: [],
              barPercentage: 0.65
            }
          ]
        },
        options: {
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: (x) => {
                return `${x.xLabel}: ${this.$t('assessments.simplifiedScoreScale').filter(t => !t.hideInScale)[this.$t('assessments.simplifiedScoreScale').filter(t => !t.hideInScale).length - x.yLabel].label}`;
              },
              title: () => {
                return '';
              }
            }
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false
                },
                ticks: {
                  fontSize: 22,
                  fontStyle: 'bold'
                }
              }
            ],
            yAxes: [
              {
                gridLines: {
                  display: true
                },
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  max: 4,
                  stepSize: 1,
                  fontSize: 16,
                  callback: (value) => {
                    if (value) {
                      return this.$t('assessments.simplifiedScoreScale').filter(t => !t.hideInScale)[this.$t('assessments.simplifiedScoreScale').filter(t => !t.hideInScale).length - value].label;
                    }
                    return '';
                  }
                }
              }
            ]
          }
        }
      }
    };
  },
  watch: {
    values: {
      immediate: false,
      deep: true,
      handler (newValues) {
        this.updateValues(newValues);
      }
    },
    showAnimation: {
      immediate: true,
      handler (newValues) {
        if (!newValues) {
          this.config.options.animation = {duration: 0};
        } else {
          delete this.config.options.animation;
        }
        if (this.chartRef) {
          if (!newValues) {
            this.chartRef.options.animation = {duration: 0};
          } else {
            delete this.chartRef.options.animation;
          }
          this.chartRef.update();
        }
      }
    },
    showLabels: {
      immediate: true,
      handler (newValues) {
        if (!newValues) {
          this.config.options.scales.xAxes.forEach(axe => {
            axe.ticks.display = false;
          });
          this.config.options.scales.yAxes.forEach(axe => {
            axe.ticks.display = false;
            axe.gridLines.display = false;
          });
        } else {
          this.config.options.scales.xAxes.forEach(axe => {
            axe.ticks.display = true;
          });
          this.config.options.scales.yAxes.forEach(axe => {
            axe.ticks.display = true;
            axe.gridLines.display = true;
          });
        }
        if (this.chartRef) {
          if (!newValues) {
            this.chartRef.options.scales.xAxes.forEach(axe => {
              axe.ticks.display = false;
            });
            this.chartRef.options.scales.yAxes.forEach(axe => {
              axe.ticks.display = false;
              axe.gridLines.display = false;
            });
          } else {
            this.chartRef.options.scales.xAxes.forEach(axe => {
              axe.ticks.display = true;
            });
            this.chartRef.options.scales.yAxes.forEach(axe => {
              axe.ticks.display = true;
              axe.gridLines.display = true;
            });
          }
          this.chartRef.update();
        }
      }
    }
  },
  mounted () {
    const ctx = this.$refs['graph-bar'];
    this.chartRef = new Chart(ctx, this.config);
    this.updateValues(this.values);
  },
  beforeDestroy () {
    this.chartRef.destroy();
  },
  methods: {
    updateValues (newValues) {
      this.config.data.labels = [];
      this.config.data.datasets[0].id = [];
      this.config.data.datasets[0].data = [];
      this.config.data.datasets[0].backgroundColor = [];
      this.config.options.scales.yAxes[0].ticks.fontSize = 10;
      this.config.options.scales.xAxes[0].ticks.fontSize = 14;

      if (newValues) {
        const assessmentNames = Object.keys(newValues);
        assessmentNames
          .filter(assessmentName => {
            return CORE_ASSESSMENT_NAMES.includes(assessmentName);
          })
          .filter(assessmentName => {
            return this.$te(`assessments.${assessmentName}`);
          })
          .map(assessmentName => {
            return this.$t(`assessments.${assessmentName}`);
          })
          .sort((a, b) => a.order - b.order)
          .forEach(assessment => {
            const scaleItem = this.$t('assessments.simplifiedScoreScale').find(e => e.name === newValues[assessment.name].simplifiedValue);
            this.chartRef.data.labels.push(assessment.label);
            this.chartRef.data.datasets[0].id.push(assessment.name);
            this.chartRef.data.datasets[0].data.push(scaleItem.value + 1);
            this.chartRef.data.datasets[0].backgroundColor.push(assessment.color);
          });
      }

      this.chartRef.update();
    },
    onSelect (assessment) {
      this.$emit('selected-assessment', assessment);
    }
  }
};
</script>

<style scoped>

</style>
